/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardPrize
 */
export interface RewardPrize {
    /**
     * 
     * @type {number}
     * @memberof RewardPrize
     */
    pointsRequired?: number;
    /**
     * 
     * @type {string}
     * @memberof RewardPrize
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardPrize
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardPrize
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RewardPrize
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RewardPrize
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardPrize
     */
    courierId?: number;
}

/**
 * Check if a given object implements the RewardPrize interface.
 */
export function instanceOfRewardPrize(value: object): value is RewardPrize {
    return true;
}

export function RewardPrizeFromJSON(json: any): RewardPrize {
    return RewardPrizeFromJSONTyped(json, false);
}

export function RewardPrizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardPrize {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsRequired': json['pointsRequired'] == null ? undefined : json['pointsRequired'],
        'name': json['name'] == null ? undefined : json['name'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function RewardPrizeToJSON(json: any): RewardPrize {
    return RewardPrizeToJSONTyped(json, false);
}

export function RewardPrizeToJSONTyped(value?: RewardPrize | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsRequired': value['pointsRequired'],
        'name': value['name'],
        'imageUrl': value['imageUrl'],
        'description': value['description'],
        'isActive': value['isActive'],
        'id': value['id'],
        'courierId': value['courierId'],
    };
}

